import { Component, Input, OnInit } from "@angular/core";
import { UserService } from "src/app/services/user.service";

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent {

    @Input() year!: number;
    @Input() versionNum!: string;
    constructor(public userService: UserService) {}

 }